export const percentage = (position: number, dimension: number) => {
  return (position * 100) / dimension;
};
